import {NextPage} from "next";
import Head from "next/head";
import {wrapper} from "../app/store";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {AccountView} from "../components/account/AccountView";

const Account: NextPage = () => {
  return <>
    <Head>
      <title>Account</title>
    </Head>
    <AccountView />
  </>
}

export const getStaticProps = wrapper.getStaticProps(store => async ({ locale }: any) => {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common', 'landing', 'auth', 'location', 'store', 'payment', 'checkout', 'order', 'affiliate', 'subscription']),
    }
  }
});

export default Account